import React, { useState } from "react";
import { Button, Box, Typography, Divider } from "@mui/material";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";

function IndExamResultModal({
  open,
  handleClose,
  selectedExam,
  tutorId,
  getTutorResults,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md")); // Detect small screens

  const [allowRetest, setAllowRetest] = useState(selectedExam?.retest);
  const allowRetestHandler = async (examId) => {
    try {
      if (!examId || !tutorId) {
        alert("Some error occured. Please try again");
        return;
      }
      await axios.put(
        // `http://localhost:8600/api/admin/allow-retest/${tutorId}/${examId}`
        `https://testapis4.el.r.appspot.com/api/tutorWeb/allow-retest/${tutorId}/${examId}`
      );
      setAllowRetest(true);
      await getTutorResults();
    } catch (err) {
      alert("Some error occured");
      console.error(err);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          width: fullScreen ? "90%" : "35%",
          maxWidth: "none",
          fontFamily: "Arial, sans-serif",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title" fontWeight="bold">
        Exam Information
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Box display="flex" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" component="span" fontWeight={600}>
            Exam ID:&nbsp;
          </Typography>
          <Typography variant="body1" component="span">
            {selectedExam.exam_id}
          </Typography>
        </Box>

        <Box display="flex" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" component="span" fontWeight="bold">
            Subject:&nbsp;
          </Typography>
          <Typography variant="body1" component="span">
            {selectedExam.subject}
          </Typography>
        </Box>

        <Box display="flex" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" component="span" fontWeight="bold">
           Total Marks:&nbsp;
          </Typography>
          <Typography variant="body1" component="span">
            {selectedExam.marks}
          </Typography>
        </Box>

        <Box display="flex" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" component="span" fontWeight="bold">
            Passing Marks:&nbsp;
          </Typography>
          <Typography variant="body1" component="span">
            {selectedExam.passing_marks}
          </Typography>
        </Box>

        <Box display="flex" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" component="span" fontWeight="bold">
            Status:&nbsp;
          </Typography>
          <Typography
            variant="body1"
            component="span"
            color={
              selectedExam.status === "fail"
                ? "red"
                : selectedExam.status === "pass"
                ? "green"
                : "inherit"
            }
          >
            {selectedExam.status}
          </Typography>
        </Box>

        <Box display="flex" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" component="span" fontWeight="bold">
            MCQ Test Status:&nbsp;
          </Typography>
          <Typography
            variant="body1"
            component="span"
            color={
              selectedExam.mcqStatus === "fail"
                ? "red"
                : selectedExam.mcqStatus === "pass"
                ? "green"
                : "inherit"
            }
          >
            {selectedExam.mcqStatus}
          </Typography>
        </Box>

        <Box display="flex" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" component="span" fontWeight="bold">
            MCQ Test Marks:&nbsp;
          </Typography>
          <Typography variant="body1" component="span">
            {+selectedExam?.mcq_marks * 4}
          </Typography>
        </Box>

        <Box display="flex" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" component="span" fontWeight="bold">
            Subjective Test Status:&nbsp;
          </Typography>
          <Typography
            variant="body1"
            component="span"
            color={
              selectedExam.subTestStatus === "fail"
                ? "red"
                : selectedExam.subTestStatus === "pass"
                ? "green"
                : "inherit"
            }
          >
            {selectedExam.subTestStatus}
          </Typography>
        </Box>

        <Box display="flex" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" component="span" fontWeight="bold">
            Subjective Marks:&nbsp;
          </Typography>
          <Typography variant="body1" component="span">
            {selectedExam.sub_marks}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          {allowRetest ? (
            <Typography
              sx={{
                color: "success.main",
              }}
              component="h4"
              // onClick={() => allowRetestHandler(selectedExam.exam_id)}
            >
              Retest Allowed
            </Typography>
          ) : (
            <Button
              color="primary"
              variant="contained"
              type="button"
              onClick={() => allowRetestHandler(selectedExam.exam_id)}
            >
              Allow Retest
            </Button>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default IndExamResultModal;
